/* Shared offer-page navigation. Loaded only where the seasonal offer bar is rendered. */
(() => {
  if (window.__dsOfferNavigation) return;
  const bar = document.querySelector('[data-ds-autumn-sale]');
  if (!bar) return;
  window.__dsOfferNavigation = true;
  const link = bar.querySelector('.ds-autumn-sale__link, [data-ds-halloween-link]');
  const slot = bar.closest('[data-ds-sale-slot]');
  const root = document.documentElement;
  const visible = element => {
    if (!element || !element.getClientRects().length) return false;
    const rect = element.getBoundingClientRect();
    const style = getComputedStyle(element);
    return rect.height > 0 && rect.width > 0 && style.display !== 'none' && style.visibility !== 'hidden';
  };
  const findBuybox = () => {
    for (const selector of ['main #buy-buttons', 'main kaching-bundle', 'main .kaching-bundles', 'main #container-bundle-selector', 'main .buy-buttons-block', 'main .product-form-buttons']) {
      const target = Array.from(document.querySelectorAll(selector)).find(visible);
      if (target) return target;
    }
    return null;
  };
  let markedTarget = null;
  let generatedId = false;
  const labelTarget = target => {
    if (markedTarget && markedTarget !== target) {
      markedTarget.removeAttribute('data-ds-offer-buybox');
      if (generatedId) markedTarget.removeAttribute('id');
      generatedId = false;
    }
    markedTarget = target;
    if (!target.id) generatedId = true;
    if (!target.id) target.id = 'ds-offer-buybox';
    target.setAttribute('data-ds-offer-buybox', '');
    if (link) link.setAttribute('href', '#' + target.id);
  };
  const scrollToBuybox = () => {
    const target = findBuybox();
    if (!target) return false;
    labelTarget(target);
    const offset = bar.getBoundingClientRect().height + 12;
    const destination = Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset);
    window.scrollTo({
      top: destination,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
    });
    return true;
  };
  const triggers = '[data-ds-halloween-link], .ds-autumn-sale__link, sticky-add-to-cart [data-scroll-to-product-information], .prod__sticky-atc .go-to, .prod__sticky-atc button[name="add"]';
  // Capture before legacy theme listeners, so the sticky CTA only navigates to the package selector.
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element) || !event.target.closest(triggers)) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!scrollToBuybox()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
  document.addEventListener('submit', event => {
    if (!(event.target instanceof Element) || !event.target.closest('.prod__sticky-atc')) return;
    if (!scrollToBuybox()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
  const initialTarget = findBuybox();
  if (initialTarget) labelTarget(initialTarget);

  if (slot) {
    // Legacy headers are out of document flow. Preserve the existing 45px slot when pinning the bar.
    let queued = false;
    const update = () => {
      queued = false;
      const headerHeight = parseFloat(getComputedStyle(root).getPropertyValue('--sf-header-height')) || 70;
      bar.toggleAttribute('data-ds-pinned', slot.getBoundingClientRect().top + headerHeight <= 0);
    };
    const requestUpdate = () => {
      if (!queued) { queued = true; requestAnimationFrame(update); }
    };
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    window.addEventListener('pageshow', requestUpdate);
    new ResizeObserver(requestUpdate).observe(slot);
    update();
  }
})();
